/* eslint-disable tss-unused-classes/unused-classes */
// all these classes are used but show up as unused
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  parentDiv: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 4,
  },
  selectItem: { width: 105 },
  scrollMenu: {
    maxHeight: 200,
    minHeight: 100,
    overflowY: 'scroll',
    scrollbarWidth: 'thin',
  },
}));

export default useStyles;
